import React from "react";

import { Box, IconButton, TextField, Tooltip } from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import CustomButton from "../../../helper-components/input/CustomButton";

import { signIn } from "../../../helper-functions/api/authQueries";
import { inputBackgroundUnblur } from "../../../helper-functions/shared/pageUtils";

import * as Constants from "../../../config/constants/Constants.js";
import { getLanguage } from "../../../config/language/language";

/**
 * Sign in form.
 *
 * Fields:
 * email
 * password
 */
export default function SignInForm(props) {
    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    React.useEffect(() => {
        document.addEventListener("visibilitychange", handleVisibilityChange);
        window.addEventListener("focus", handleWindowFocus);

        inputBackgroundUnblur(3, 1.2, "password", "signInBackground");

        // Focus on password input after page load
        if (props.browser.isPageLoading) {
            setTimeout(handleFocus, Constants.PAGE_LOADING_MS);
        } else {
            handleFocus();
        }

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener("focus", handleWindowFocus);
        };
    }, []);

    const handleFocus = () => {
        const focusEl = document.getElementById("email");

        if (focusEl) {
            setTimeout(() => focusEl.focus(), 100);
        }
    };

    const handleWindowFocus = () => {
        handleFocus();
    };

    const handleVisibilityChange = () => {
        if (document.visibilityState === "visible") {
            handleFocus();
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.target);

        signIn(props, data);
    };

    return (
        <Box component="form" id="signinForm" onSubmit={handleSubmit} sx={{ mt: 1 }}>
            <TextField margin="normal" required fullWidth name="email" label="Email" type="email" id="email" autoComplete="email" />

            <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                id="password"
                autoComplete="current-password"
                type={showPassword ? "text" : "password"}
                InputProps={{
                    endAdornment: (
                        <Tooltip title={`${showPassword ? "Hide" : "Show"} password`} arrow>
                            <IconButton onClick={handleClickShowPassword}>{showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}</IconButton>
                        </Tooltip>
                    )
                }}
            />

            <CustomButton {...props} title={getLanguage().BUTTON_SIGNIN} type="submit" fullWidth />
            <CustomButton {...props} title={getLanguage().BUTTON_NO_ACCOUNT} path="/signup" variant="text" />
        </Box>
    );
}
